import { DoctorRegistrationSteps } from 'common/enum/doctor-overall-registration-steps'

interface SelectFieldItem {
  label: string
  value: string
}

export const timeCourseOptions: SelectFieldItem[] = [
  {
    label: 'Hoje',
    value: 'today'
  },
  {
    label: 'Últimos 7 dias',
    value: 'last-7-days'
  },
  {
    label: 'Últimos 30 dias',
    value: 'last-30-days'
  },
  {
    label: 'Último trimestre',
    value: 'last-trimester'
  },
  {
    label: 'Acima de 3 meses',
    value: 'over-3-months'
  }
]

export const pendenciesStepInitials = [
  {
    inital: 'TERM.',
    step: DoctorRegistrationSteps.TERMS
  },
  {
    inital: 'D.PES.',
    step: DoctorRegistrationSteps.PERSONAL_DATA
  },
  {
    inital: 'CONTA.',
    step: DoctorRegistrationSteps.CONTACTS
  },
  {
    inital: 'ENDER.',
    step: DoctorRegistrationSteps.ADDRESS
  },
  {
    inital: 'D.PROF.',
    step: DoctorRegistrationSteps.PROFESSIONAL_DATA
  },
  {
    inital: 'F.ACAD.',
    step: DoctorRegistrationSteps.ACADEMIC_EDUCATION
  },
  {
    inital: 'ESPEC.',
    step: DoctorRegistrationSteps.SPECIALTIES
  },
  {
    inital: 'SETOR.',
    step: DoctorRegistrationSteps.SECTORS_OF_ACTIVITY
  },
  {
    inital: 'PRIVI.',
    step: DoctorRegistrationSteps.MEDICAL_PRIVILEGES
  },
  {
    inital: 'SERVI.',
    step: DoctorRegistrationSteps.ATTENDANCES
  },
  {
    inital: 'EQUI.',
    step: DoctorRegistrationSteps.TEAMS
  },
  {
    inital: 'IMUNI.',
    step: DoctorRegistrationSteps.IMUNNIZATION
  },
  {
    inital: 'DOCS.',
    step: DoctorRegistrationSteps.DOCUMENTS_AND_ATTACHMENTS
  },
  {
    inital: 'CNES',
    step: DoctorRegistrationSteps.CNES
  }
]

export const queryParams = [
  'data {',
  'doctor_register_id',
  'doctor_id',
  'status',
  'sentToDirector',
  'approvedAt',
  'isEmergency',
  'sentToDirectorAt',
  'steps {status, name}',
  `doctor {
    name
    specialties {
      name
      isMain
      code
    }
    crm
    crmUf
    specialties {
      isMain
      name
    }
    councilRegister {
      crm
    }
    sectors
    getDoctorRecommendation {
      createdAt
      emergency
      recommended_by_id
    }
    immunization {
      description
      immunized
    }
  }`,
  '}',
  'pageInfo {currentPage, itemsPerPage, totalItems, totalPages}'
]
